(function(){
  var d=document,w=window;
  d.querySelectorAll('.sb-vhero').forEach(function(r){
    var v=r.querySelector('video'),b=r.querySelector('[data-vhero-toggle]'),user=false,ready=false,started=false;
    var st=parseFloat(r.getAttribute('data-start'))||0;
    function s(p){if(b){b.setAttribute('aria-pressed',p?'true':'false');b.setAttribute('aria-label',p?'Play video':'Pause video');}}
    function go(){if(!v||!started||user||!ready||!v.paused)return;var p=v.play();if(p&&p.then)p.then(function(){s(false)}).catch(function(){});}
    function start(){
      if(!v||started)return;started=true;
      var src=(w.innerWidth<750?v.getAttribute('data-src-m'):v.getAttribute('data-src-d'))||v.getAttribute('data-src-d');if(!src)return;
      v.muted=true;v.defaultMuted=true;v.playsInline=true;v.loop=true;v.setAttribute('muted','');v.setAttribute('playsinline','');
      v.preload='auto';v.src=src+(st>0?'#t='+st:'');
      v.addEventListener('loadedmetadata',function(){if(st>0&&v.currentTime<st-.15){try{v.currentTime=st}catch(e){}}else{ready=true;go()}},{once:true});
      v.addEventListener('seeked',function(){if(!ready){ready=true;go()}});
      setTimeout(function(){if(!ready){ready=true;go()}},4000);
      ['canplay','suspend','stalled'].forEach(function(e){v.addEventListener(e,go)});
      v.addEventListener('pause',function(){if(!user)setTimeout(go,250)});
      v.addEventListener('playing',function(){s(false)});
      d.addEventListener('visibilitychange',function(){if(!d.hidden)go()});
      var kick=function(){go();if(!v.paused)['pointerdown','touchstart','scroll','keydown'].forEach(function(e){w.removeEventListener(e,kick,true)})};
      ['pointerdown','touchstart','scroll','keydown'].forEach(function(e){w.addEventListener(e,kick,{capture:true,passive:true})});
      v.load();
    }
    if(v){
      /* load the video only after the page itself is ready: the poster (same frame) is the first paint */
      if(d.readyState==='complete')setTimeout(start,200);
      else{w.addEventListener('load',function(){setTimeout(start,200)},{once:true});setTimeout(start,3500);}
      w.addEventListener('pageshow',go);
      if(b)b.addEventListener('click',function(){start();if(v.paused){user=false;ready=true;v.play();s(false);}else{user=true;v.pause();s(true);}});
    }
    /* scroll: hero recedes while the next section slides over it */
    var t=false,lp=-1;function u(){t=false;var h=r.offsetHeight||1,p=Math.min(1,Math.max(0,w.scrollY/h));p=Math.round(p*500)/500;if(p!==lp){lp=p;r.style.setProperty('--vh-p',p);}}
    w.addEventListener('scroll',function(){if(!t){t=true;requestAnimationFrame(u)}},{passive:true});w.addEventListener('resize',u);u();
  });
  /* section after the hero: scroll-linked fly-in (--in) and fly-out (--out) */
  var nx=d.querySelector('.shopify-section:has(.sb-vhero) + .shopify-section');
  if(nx){
    nx.classList.add('vh-next');
    var t2=false,li=-1,lo=-1;
    function f(){t2=false;var vh=w.innerHeight,rc=nx.getBoundingClientRect();
      var x=Math.min(1,Math.max(0,(vh-rc.top)/(vh*.78)));x=1-Math.pow(1-x,3);x=Math.round(x*500)/500;
      var o=Math.min(1,Math.max(0,-rc.top/(rc.height*.85)));o=o*o;o=Math.round(o*500)/500;
      if(x!==li){li=x;nx.style.setProperty('--in',x);}
      if(o!==lo){lo=o;nx.style.setProperty('--out',o);}
    }
    w.addEventListener('scroll',function(){if(!t2){t2=true;requestAnimationFrame(f)}},{passive:true});w.addEventListener('resize',f);f();
  }
})();
